module.exports = __webpack_public_path__ + "img/icon_bodyshop.8aa91d42.png";